module.exports = __webpack_public_path__ + "img/Recurso 34@300xy.eda72a62.png";